import React, { useState, useEffect, useContext, useRef } from "react";
import MyCrousal from "components/crousal";
import Input from "components/input";
import ActiveStepIndicator from "components/shared/activeStepIndicator";
import { Observer } from "mobx-react";
import { MobXProviderContext } from "mobx-react";

const Step4 = ({ disableButton }) => {
  const { onboardingStore } = useContext(MobXProviderContext);
  const headingRef = useRef();

  const dietaryPreferences = onboardingStore.dietaryPreferences;

  const cuisineTypes = onboardingStore.cuisineTypes;

  const cuisines = onboardingStore.selectedCuisines;

  const selectedCuisines =
    cuisines?.length > 0
      ? cuisines.map((cuisineObj) => {
          const itemName = Object.keys(cuisineObj)[0];
          const review = cuisineObj[itemName];
          return { name: itemName, review: review };
        })
      : [];

  const selectedDietaryPreferences =
    onboardingStore.location?.meal_serieses_attributes[0]?.meal_plan_preference_attributes?.dietary_preferences?.split(
      ", "
    );

  const [selectedCuisineTypes, setSelectedCuisineTypes] = useState(
    selectedCuisines || []
  );
  const [dietPreference, setDietPreference] = useState(
    selectedDietaryPreferences || []
  );
  const [additionalPreference, setAdditionalPreference] = useState(
    onboardingStore.location?.meal_serieses_attributes[0]
      ?.meal_plan_preference_attributes?.additional_notes || ""
  );
  const [allCuisineTypes, setAllCuisineTypes] = useState([]);

  const [selectedCuisinesOnFE, setSelectedCuisinesOnFE] = useState(
    onboardingStore.selectedCuisinesOnFe || []
  );

  useEffect(() => {
    disableButton(false);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      headingRef?.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  }, []);

  useEffect(() => {
    const formattedCuisines = cuisineTypes.reduce((acc, type) => {
      const foundCuisine = selectedCuisineTypes?.find(
        (selectedType) => selectedType.name === type?.name
      );

      const review = foundCuisine ? foundCuisine?.review : "neutral";

      acc[type?.name] = review;

      return acc;
    }, {});

    onboardingStore.handlePreferencesData(
      allCuisineTypes,
      dietPreference,
      additionalPreference,
      formattedCuisines
    );
  }, [
    selectedCuisineTypes,
    allCuisineTypes,
    additionalPreference,
    dietPreference,
  ]);

  useEffect(() => {
    handleAllCuisineTypes();
  }, [selectedCuisineTypes]);

  const handleAllCuisineTypes = () => {
    const allCuisineTypes = cuisineTypes?.map((type) => {
      const foundCuisine = selectedCuisineTypes?.find(
        (selectedType) => selectedType.name == type.name
      );
      if (foundCuisine) {
        const newObj = {};
        newObj[type?.name] = foundCuisine?.review;
        return newObj;
      } else {
        return {
          [type?.name]: "neutral",
        };
      }
    });

    setAllCuisineTypes(allCuisineTypes);
  };

  const handleDietaryPreferenceClick = (value) => {
    if (dietPreference?.includes(value)) {
      setDietPreference((prevDays) => prevDays?.filter((day) => day !== value));
    } else {
      setDietPreference((prevDays) => [...prevDays, value]);
    }
  };

  const handleCuisineTypeClick = (name, review) => {
    setSelectedCuisineTypes((prevCuisines) => {
      const existingCuisineIndex = prevCuisines?.findIndex(
        (cuisine) => cuisine.name == name
      );

      if (existingCuisineIndex !== -1) {
        return prevCuisines?.map((cuisine, index) =>
          index === existingCuisineIndex ? { name, review } : cuisine
        );
      } else {
        return [...prevCuisines, { name, review }];
      }
    });

    setSelectedCuisinesOnFE((prevSelectedCuisines) => {
      const existingIndex = prevSelectedCuisines?.findIndex(
        (cuisine) => cuisine.name === name
      );

      if (existingIndex !== -1) {
        if (prevSelectedCuisines[existingIndex]?.review === review) {
          // If the cuisine exists with the same review, remove it
          return prevSelectedCuisines?.filter(
            (cuisine, index) => index !== existingIndex
          );
        } else {
          // If the cuisine exists with a different review, update it
          return prevSelectedCuisines?.map((cuisine, index) =>
            index === existingIndex ? { name, review } : cuisine
          );
        }
      } else {
        // If the cuisine doesn't exist, add it
        return [...prevSelectedCuisines, { name, review }];
      }
    });
  };

  const handleAdditionalPreference = (value) => {
    setAdditionalPreference(value);
  };

  useEffect(() => {
    onboardingStore.setSelectedCuisineOnFe(selectedCuisinesOnFE);
  }, [selectedCuisinesOnFE]);

  return (
    <Observer>
      {() => (
        <>
          <div ref={headingRef}>
            <ActiveStepIndicator step={4} />
          </div>

          <div className="flex-col flex" id="carousal">
            <div className="flex inline-flex mb-6">
              <div className="expected-bag-text screen-xs:w-full-235 font-inter-semibold">
                How does your team feel about the following cuisines?
              </div>
            </div>

            <div className="screen-lg:hidden screen-md:hidden screen-sm:flex mb-0.5 w-full screen-xs:w-full-215">
              <div className="screen-lg:inline-flex screen-md:inline-flex">
                {cuisineTypes?.map((cuisine, index) => (
                  <div
                    key={index}
                    className={`screen-lg:mr-3 screen-md:mr-3 mt-4 screen-lg:mt-0 screen-md:mt-0 px-4 py-3 hover:cursor-pointer text-slate-700 font-inter-medium text-sm leading-[14px] ${
                      selectedCuisineTypes?.some(
                        (cuisineType) =>
                          cuisineType.name == cuisine.name &&
                          cuisineType.review == "like"
                      )
                        ? "bg-indigo-500 text-white "
                        : "bg-slate-50 hover:bg-indigo-500 hover:text-white "
                    } rounded-3xl justify-start screen-lg:justify-center screen-md:justify-center gap-2 flex  `}
                    onClick={() => {
                      handleCuisineTypeClick(cuisine.name, "like");
                    }}
                  >
                    {cuisine.name}
                  </div>
                ))}
              </div>
            </div>

            <div className="hidden screen-lg:block screen-md:block">
              <MyCrousal
                dietaryPreferences={cuisineTypes}
                handleReviewButton={handleCuisineTypeClick}
                selectedCuisines={selectedCuisineTypes}
                selectedCuisinesOnFE={selectedCuisinesOnFE}
              />
            </div>

            <div className="screen-xs:w-full-235 mb-4">
              <p className="expected-bag-text font-inter-semibold">
                Dietary preferences
              </p>
              <p className="text-slate-700 font-inter-normal text-base leading-tight">
                Please select any dietary restrictions or allergies on your team
                we should be aware of
              </p>
            </div>

            <div className="mb-0.5 w-full screen-xs:w-full-215 mb-6">
              <div className="screen-lg:inline-flex screen-md:inline-flex">
                {dietaryPreferences?.map((value, index) => (
                  <div
                    key={index}
                    className={`screen-lg:mr-3 screen-md:mr-1 mt-4 screen-lg:mt-0 screen-md:mt-0 px-4 py-3 hover:cursor-pointer text-slate-700 font-inter-medium text-sm leading-[14px] ${
                      dietPreference?.some((diet) => diet == value)
                        ? "bg-indigo-500 text-white "
                        : "bg-slate-50 hover:bg-indigo-500 hover:text-white "
                    } rounded-3xl justify-start screen-lg:justify-center screen-md:justify-center gap-2 flex`}
                    onClick={() => handleDietaryPreferenceClick(value)}
                  >
                    {value}
                  </div>
                ))}
              </div>
            </div>

            <div className="w-full mb-6">
              <Input
                text={
                  "Any additional preferences or dietary restrictions on your team?"
                }
                placeholder={"ex. Halal Food"}
                otherMealName={handleAdditionalPreference}
                mealName={additionalPreference}
                isCompulsary={false}
              />
            </div>
          </div>
        </>
      )}
    </Observer>
  );
};

export default Step4;
